<template>
    <div id="chatContextMenu" >

        <!-- 채팅창에서 유저 닉네임 클릭시 표시되는 하부 메뉴 -->
        <div class="user_nick">

            <p>{{userinfo.nic?userinfo.nic:userinfo.from}}</p>
        </div>
        <ul>
            <li>
                <span @click="ready()" class="ready">유저정보</span>
            </li>
            <!-- 본인이 아닐때만 -->
            <template v-if="userNic !== user.nic && isAuth">
                <li>
                    <span @click="popMessage(userinfo.nic?userinfo.nic:userinfo.from)">쪽지보내기</span>
                </li>
                <li>
                    <span @click="request_mtmchat()">채팅신청</span>
                </li>
                <li>
                    <span @click="addFriend(userinfo.nic?userinfo.nic:userinfo.from)">친구등록</span>
                </li>

                <!-- 현재 접속 유저가 방장 일때 -->
                <template v-if="isOwner">
                    <li class="addManager" @click="addManager()">
                        <span >
                            {{ switchManager }}
                        </span>
                    </li>
                    <li class="forcedOut" @click="forcedOut()">
                        <span >
                            {{ switchForceOut }}
                        </span>
                    </li>
                </template>
            </template>
            <!--
            <li>
                블랙리스트
            </li> -->
        </ul>
    </div>
</template>

<script>
import io from "socket.io-client";
import { newPop } from '@/utils/popup.js';
import { auth } from '@/components/mixins/auth.js';

export default {
    data(){
        return{
            socket: io(this.$store.state.serverDomain + ":3000"),
        }
    },
    props:[
        'userinfo','roominfo'
    ],
    mixins:[ auth ],
    computed: {
        userNic()
        {
            return this.userinfo.nic?this.userinfo.nic:this.userinfo.from;
        },
        isOwner()//접속자 기준
        {
            if(this.roominfo){
                return this.user.id === this.roominfo.user_id;
            }else{
                return false;
            }

        },
        isManagerNow()//접속자 기준
        {
            if(this.roominfo && this.roominfo.manager.find((manager)=>manager.user_id === this.user.id))
            {
                return true;
            }else{
                return false;
            }
        },
        isManager()
        {
            if(this.roominfo && this.roominfo.manager.find((manager)=>manager.user_id === this.userinfo.id))
            {
                return true;
            }else{
                return false;
            }
        },
        isForceOut()
        {
            if(this.roominfo && this.roominfo.ban.find((ban)=>ban.user_id === this.userinfo.id))
            {
                return true;
            }else{
                return false;
            }
        },
        switchManager() {
            if (this.isManager) {
                return "매니저 제외";
            } else {
                return "매니저 등록";
            }
        },
         switchForceOut() {
            if (this.isForceOut) {
                return "강퇴 해제";
            } else {
                return "강퇴처리";
            }
        },
    },
    methods:{
        popMessage(nic)
        {
                //아이템이 있을시
            const url="/pop/message/Write/"+nic;
            newPop('Msg_window',url,'','',800,400);
        },
        ready(){
            alert('준비중입니다.');
        },
        async addManager()
        {
            if(this.userinfo.id ==0)
            {
                alert('비회원입니다.');
                return;
            }
            try {
                const response = await this.$store.dispatch("chat/addManager", {user_id: this.userinfo.id,owner_id:this.roominfo.user_id});
                console.log(response);

                this.$flashMessage.show({
                    type: response.status_code===201?"info":"error",
                    title: response.message,
                    message: response.message,
                });

                //상태 변경 알림
                let params = {
                    room_id:this.roominfo.id,
                    description:'매니저 변경'
                }
                this.socket.emit("UpdateRoom", params, function (callback) {
                    console.log(callback);
                });
            }catch(error){
                console.log(error);
                 this.$flashMessage.show({
                    type: "error",
                    title: error,
                    message: error,
                });
            }
        },
        async forcedOut()
        {

            try {
                const response = await this.$store.dispatch("chat/forcedOut", {user_id: this.userinfo.id,owner_id:this.roominfo.user_id});
                console.log(response);

                this.$flashMessage.show({
                    type: response.status_code===201?"info":"error",
                    title: response.message,
                    message: response.message,
                });

                //상태 변경 알림
                let params = {
                    room_id:this.roominfo.id,
                    description: this.userNic +' 강퇴 되었습니다.',
                    ban:response.user_ban,
                    user_id:this.userinfo.id,
                    type:'forcedout'
                }
                this.socket.emit("UpdateRoom", params, function (callback) {
                    console.log(callback);
                });

            }catch(error){
                console.log(error);
                 this.$flashMessage.show({
                    type: "error",
                    title: error,
                    message: error,
                });
            }
        },
        async request_mtmchat(){
            //this.$emit('request-mtm')

            //console.log('1대1대화 신청',this.userinfo.socketid);
            //console.log(this.$store.getters.currentUser.nic);
            //alert(this.userinfo.id);
            if(this.userinfo.id ==0)
            {
                alert('비회원으로 조회가 불가능 합니다.');
                return;
            }
            //아이템 판단
            //아이템 유무 확인 있으면 사용유무를 묻고 없으면 구매유무를 확인한다.
            //방장과 매니저는 참여자에게 1:1채팅 신청 무료
            let ckitem = true;
            if( !this.roominfo || (!this.isOwner && !this.isManagerNow) )
            {
                ckitem =  await this.ckItem('chat_mtm','pop','','1:1 채팅 이용권');
            }
            if(!ckitem){
                return;
            }else{
                //아이템이 있을시
                let params = {
                    fromNic:this.user.nic,
                    fromId:this.user.id,
                    tosocketid:this.userinfo.socketid,
                    toNic:(this.userinfo.nic?this.userinfo.nic:this.userinfo.from),
                    room:'mtm_'+this.user.id+'_'+this.userinfo.id
                };
                this.socket.emit("requestMtm", params, function (callback) {
                    if (callback==="success") {

                    const url="/chat/mtm/"+params.room;
                        newPop('mtm_'+params.room,url,'','',500,400);
                    }else{
                        alert(callback);
                    }
                });
                //채팅 신청 하고 채팅방 진입
            }
        },


    }
}
</script>

<style lang="scss" scoped>
#chatContextMenu{
    font-size:12px;
    background:#eee;
    border:1px solid #F20732;
    display:inline-block;
    .user_nick{
       background:#F20732;
       line-height: 15px;
       p{
           margin:0;
           padding:5px;
           color:#fff;
           font-weight:bold
       }
    }
    ul{
        margin:0;padding:0;
        li{
            padding:3px;
            line-height: 15px;
            cursor:pointer;
            .ready{
                color:#ccc;
            }
        }
        li:hover{
            background:#F2C3A7
        }
        .addManager{
            background:#1584eb;
            color:white;
        }
        .forcedOut{
            background:#eb154e;
            color:white;
        }
    }
}
</style>
